import React, { useState } from 'react';

import BoxConteudo from '../../../../../../../components/BoxConteudo';
import CustomCol from '../../../../../../../components/CustomCol';
import CustomRow from '../../../../../../../components/CustomRow';
import Input from '../../../../../../../components/InputNew';
import Select from '../../../../../../../components/InputNew/Select';
import Log from '../../../../../../../components/Log/Log';
import WorkspaceFicha from '../../../../../../../components/WorkspaceFicha';
import RegistroEntrega from '../registroEntrega';

const ItemEntregaPlanoForm: React.FC = () => {
  const [formData, setFormData] = useState({
    idParcela: '',
    produtoFarmaceutico: '',
    idProduto: '',
    status: '',
    ufDestino: '',
    dataPrevista: '',
    dataUltEntrega: '',
    qtdPrevista: '',
    qtdEntregue: '',
    observacoes: '',
  });
  const logs = {};

  const handleChange = (name: string, value: any) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <WorkspaceFicha>
      <Log {...logs} entity="TB_ORG_INTER" id={Number(1)} />
      <BoxConteudo boxTitulo="Informações da Entrega">
        {/* Linha 1 */}
        <CustomRow>
          <CustomCol width="33%">
            <Input
              label="ID da Parcela"
              type="text"
              name="idParcela"
              value={formData.idParcela}
              onChange={(e) => handleChange('idParcela', e.target.value)}
              readOnly
            />
          </CustomCol>

          <CustomCol width="33%">
            <Input
              label="Produto Farmacêutico"
              type="text"
              name="produtoFarmaceutico"
              value={formData.produtoFarmaceutico}
              onChange={(e) =>
                handleChange('produtoFarmaceutico', e.target.value)
              }
            />
          </CustomCol>

          <CustomCol width="33%">
            <Input
              label="ID do Produto"
              type="text"
              name="idProduto"
              value={formData.idProduto}
              onChange={(e) => handleChange('idProduto', e.target.value)}
            />
          </CustomCol>
        </CustomRow>

        {/* Linha 2 */}
        <CustomRow>
          <CustomCol width="20%">
            <Select
              label="Status"
              name="status"
              value={formData.status}
              options={[
                { label: 'Pendente', value: 'pendente' },
                { label: 'Em andamento', value: 'andamento' },
                { label: 'Concluída', value: 'concluida' },
                { label: 'Cancelada', value: 'cancelada' },
              ]}
              onChange={(e) => handleChange('status', e.target.value)}
            />
          </CustomCol>

          <CustomCol width="20%">
            <Select
              label="UF Destino"
              name="ufDestino"
              value={formData.ufDestino}
              options={[
                { label: 'DF', value: 'DF' },
                { label: 'SP', value: 'SP' },
                { label: 'RJ', value: 'RJ' },
                { label: 'MG', value: 'MG' },
                { label: 'BA', value: 'BA' },
                // ...adicione as demais UFs se quiser
              ]}
              onChange={(e) => handleChange('ufDestino', e.target.value)}
            />
          </CustomCol>

          <CustomCol width="20%">
            <Input
              label="Data Prevista"
              type="date"
              name="dataPrevista"
              value={formData.dataPrevista}
              onChange={(e) => handleChange('dataPrevista', e.target.value)}
            />
          </CustomCol>

          <CustomCol width="20%">
            <Input
              label="Data Últ. Entrega"
              type="date"
              name="dataUltEntrega"
              value={formData.dataUltEntrega}
              onChange={(e) => handleChange('dataUltEntrega', e.target.value)}
              readOnly
            />
          </CustomCol>

          <CustomCol width="10%">
            <Input
              label="Qtd Prevista"
              type="number"
              name="qtdPrevista"
              value={formData.qtdPrevista}
              onChange={(e) => handleChange('qtdPrevista', e.target.value)}
            />
          </CustomCol>

          <CustomCol width="10%">
            <Input
              label="Qtd Entregue"
              type="number"
              name="qtdEntregue"
              value={formData.qtdEntregue}
              onChange={(e) => handleChange('qtdEntregue', e.target.value)}
              readOnly
            />
          </CustomCol>
        </CustomRow>

        {/* Linha 3 */}
        <CustomRow>
          <CustomCol width="100%">
            <Input
              label="Observações"
              name="observacoes"
              type="textarea"
              linhas={4}
              value={formData.observacoes}
              onChange={(e) => handleChange('observacoes', e.target.value)}
            />
          </CustomCol>
        </CustomRow>
      </BoxConteudo>

      <RegistroEntrega />
    </WorkspaceFicha>
  );
};

export default ItemEntregaPlanoForm;
